import script from "./findPasswordModel.vue?vue&type=script&setup=true&lang=js"
export * from "./findPasswordModel.vue?vue&type=script&setup=true&lang=js"

import "./findPasswordModel.vue?vue&type=style&index=0&id=74df85d5&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74df85d5"]])

export default __exports__